import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Slot from '../components/slot';

interface SlotElement extends Element {
  props: Element['props'] & {
    slotId: string;
    'data-slot-id': string;
  };
}

const slot: Processor<SlotElement> = {
  priority: 10,
  name: 'slot',
  test: ({ node }) =>
    node.props?.hasOwnProperty('data-slot-id') &&
    !!node.props?.className &&
    node.props.className.includes('wp-block-erom-slot'),
  processor: ({ node }) => {
    node.props.slotId = node.props['data-slot-id'];
    node.component = Slot as ComponentType;

    return node;
  }
};

export default slot;
